import { combineReducers } from 'redux'
import {
  updateObject,
  createReducer,
} from 'helpers/ReducerUtil'
import {
  CLEAR_COMMENT_LIST,
  UPDATE_COMMENT_LIST,
} from './constants'

const clear = () => []
const updateComments = (comments, action) => action.comments ? [...action.comments] : []

const comments = createReducer([], {
  [CLEAR_COMMENT_LIST]: clear,
  [UPDATE_COMMENT_LIST]: updateComments,
})

export default comments
